import React from "react";

// Helpers
import cloneDeep from "lodash.clonedeep";

// Custom components
import SplitComparison from "../SplitComparison/SplitComparison";
import OpacityComparison from "../OpacityComparison/OpacityComparison";

function ComparisonMenu(props) {
  const pairData = props.comparisonItems[props.currentComparisonIndex];
  const updatePositionOneSplit = (data) => {
    const updatedComparisonItems = cloneDeep([...props.comparisonItems]);
    if (pairData.lockToggleSplit) {
      updatedComparisonItems[props.currentComparisonIndex].positionSplit = {
        x: data.x,
        y: data.y,
      };
    } else {
      updatedComparisonItems[
        props.currentComparisonIndex
      ].imageOnePositionSplit = {
        x: data.x,
        y: data.y,
      };
    }
    props.setComparisonItems(updatedComparisonItems);
  };

  const updatePositionTwoSplit = (data) => {
    const updatedComparisonItems = cloneDeep([...props.comparisonItems]);
    if (pairData.lockToggleSplit) {
      updatedComparisonItems[props.currentComparisonIndex].positionSplit = {
        x: data.x,
        y: data.y,
      };
    } else {
      updatedComparisonItems[
        props.currentComparisonIndex
      ].imageTwoPositionSplit = {
        x: data.x,
        y: data.y,
      };
    }
    props.setComparisonItems(updatedComparisonItems);
  };

  const updatePositionOneOpacity = (data) => {
    const updatedComparisonItems = cloneDeep([...props.comparisonItems]);

    if (pairData.lockToggleOpacity) {
      updatedComparisonItems[props.currentComparisonIndex].positionOpacity = {
        x: data.x,
        y: data.y,
      };
    } else {
      updatedComparisonItems[
        props.currentComparisonIndex
      ].imageOnePositionOpacity = {
        x: data.x,
        y: data.y,
      };
    }
    props.setComparisonItems(updatedComparisonItems);
  };

  const updatePositionTwoOpacity = (data) => {
    const updatedComparisonItems = cloneDeep([...props.comparisonItems]);
    if (pairData.lockToggleOpacity) {
      updatedComparisonItems[props.currentComparisonIndex].positionOpacity = {
        x: data.x,
        y: data.y,
      };
    } else {
      updatedComparisonItems[
        props.currentComparisonIndex
      ].imageTwoPositionOpacity = {
        x: data.x,
        y: data.y,
      };
    }
    props.setComparisonItems(updatedComparisonItems);
  };

  const handleStart = () => {};
  const handleEnd = () => {};

  return (
    <div className="flex flex-col items-center justify-center w-full h-full">
      {/* Unmount for better performance */}
      {props.currentMenu === "split" && (
        <SplitComparison
          setComparisonItems={props.setComparisonItems}
          comparisonItems={props.comparisonItems}
          currentComparisonIndex={props.currentComparisonIndex}
          handleStart={handleStart}
          handleEnd={handleEnd}
          updatePositionOneSplit={updatePositionOneSplit}
          updatePositionTwoSplit={updatePositionTwoSplit}
          touchControls={props.touchControls}
        />
      )}

      {props.currentMenu === "opacity" && (
        <OpacityComparison
          setComparisonItems={props.setComparisonItems}
          comparisonItems={props.comparisonItems}
          currentComparisonIndex={props.currentComparisonIndex}
          handleStart={handleStart}
          handleEnd={handleEnd}
          updatePositionOneOpacity={updatePositionOneOpacity}
          updatePositionTwoOpacity={updatePositionTwoOpacity}
          touchControls={props.touchControls}
        />
      )}
    </div>
  );
}

export default ComparisonMenu;
